import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Link, Outlet } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './amplify-config';

Amplify.configure(amplifyConfig)

console.count("renders")

function App() {
  return (
    <div className="App">
      <nav>
        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", listStyleType: "none", gap: "2rem", padding: "20px 0px 20px 0px"}}>
        <li><Link to={"/"}>Home</Link></li>
          <li><Link to={"/series"}>Series</Link></li>
          <li><Link to={"/series/first"}>First Series</Link></li>
          <li><Link to={"/series/second"}>Second Series</Link></li>
          <li><Link to={"/about"}>About</Link></li>
          <li><Link to={"/profile"}>Profile</Link></li>
        </div>
      </nav>
      <Outlet />
    </div>
  );
}

export default App;
